import React from 'react';
import { useRef } from 'react';
import {
    Button,
} from 'react-bootstrap';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectTax from './SelectTax';
import FormGroupModoVisualizacao from './FormGroupModoVisualizacao';
import IntervaloDataFilter from './IntervaloDataFilter';
import CONSTANTS from '../constants';

export default function FiltersMenu(props) {
    const filtersRef = useRef(null);

    if (JSON.stringify(props.filters) !== filtersRef.current) {
        filtersRef.current = JSON.stringify(props.filters);
    }

    const changeFilter = (newFilter) => {
        // console.log({FiltersMenuChangeFilter: newFilter});
        props.onChange(newFilter);
    };

    const resetFilters = () => {
        let tipoGroup = CONSTANTS.TIPOS_DE_FICHA;
        for (let i of CONSTANTS.TIPOS_DE_FICHA.keys()) {
            tipoGroup[i].active = true;
        }
        changeFilter({
            ...CONSTANTS.emptyFilters,
            tipoGroup: tipoGroup,
            modo: props.filters.modo
        });
    };

    const isMobile = (props.intervaloData !== null);

    return (
        <>
            {Object.keys(props.fichas).length > 0 &&
                <div className={ `menuFiltrosWrapper ${props.className}` }>
                    <div className="menuFiltros" ref={props.menuFiltrosRef}>
                        <FormGroupModoVisualizacao
                            value={props.filters.modo}
                            onChange={changeFilter}
                            isMobile={isMobile}
                        />

                        {props.filters.modo === 'mapa' &&
                            <FormControl fullWidth className="mt-4">
                                <InputLabel>Recorte territorial</InputLabel>
                                <Select
                                    id="selectRecorteTerritorial"
                                    key="selectRecorteTerritorial"
                                    onChange={(e) => {
                                        changeFilter({recorteTerritorial: e.target.value});
                                    }}
                                    value={props.filters.recorteTerritorial}
                                >
                                    <MenuItem
                                        key="nenhum"
                                        value="-1"
                                        disabled={props.qtdeFichas > CONSTANTS.MAPA_THRESHOLD.PTS[props.isMobile ? 'mobile' : 'desktop']}
                                    >
                                        Nenhum
                                    </MenuItem>
                                    {Object.keys(CONSTANTS.RECORTES_TERRITORIAIS).map((id) => (
                                        <MenuItem key={id} value={id}>
                                            {CONSTANTS.RECORTES_TERRITORIAIS[id].plural}
                                        </MenuItem>
                                    ))}
                                    <MenuItem
                                        key={CONSTANTS.SUB_RECORTES_TERRITORIAIS.municipio.id}
                                        value={CONSTANTS.SUB_RECORTES_TERRITORIAIS.municipio.id}
                                        disabled={!(props.filters.localizacao.length === 1 && props.filters.localizacao[0].tax ===  'uf')}
                                    >
                                        {CONSTANTS.SUB_RECORTES_TERRITORIAIS.municipio.plural}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        }

                        <FormControl fullWidth className="mt-3">
                            <label>
                                Tipos de cadastro
                            </label>
                            <List id="tiposDeCadastro">
                                {CONSTANTS.TIPOS_DE_FICHA.map((tipo, index) => (
                                    <ListItem
                                        disablePadding
                                        key={`tipoGroup_${tipo.id}`}
                                    >
                                        <ListItemButton
                                            id={`tipoGroup_${tipo.id}`}
                                            className={props.filters.tipoGroup[index].active ? 'habilitado' : 'desabilitado'}
                                            onClick={(e, b) => {
                                                const id = e.currentTarget.id.split('_')[1];
                                                const tipoGroup = props.filters.tipoGroup.map((tipoG) => {
                                                    if (tipoG.id === id) {
                                                        tipoG.active = !tipoG.active;
                                                    }
                                                    return tipoG;
                                                });
                                                changeFilter({tipoGroup: tipoGroup});
                                            }}
                                        >
                                            <ListItemIcon>
                                                <FontAwesomeIcon
                                                    icon={"eye"}
                                                    className={`tiposDeCadastroIcones tiposDeCadastroIcones_${tipo.id}`}
                                                />
                                            </ListItemIcon>
                                            <ListItemText>
                                                {tipo.plural} {props.fichas.hasOwnProperty(tipo.id) ? `(${props.fichas[tipo.id].length})` : ''}
                                            </ListItemText>
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </FormControl>

                        <h3>Filtros disponíveis</h3>

                        <FormControl fullWidth className="mt-3">
                            <SelectTax
                                key={`selectTax_${CONSTANTS.TAXONOMIAS_FILTROS[0].slug}`}
                                tax={CONSTANTS.TAXONOMIAS_FILTROS[0]}
                                isMobile={props.isMobile}
                                filtersTax={props.filters[CONSTANTS.TAXONOMIAS_FILTROS[0].slug]}
                                opcoesTax={props.opcoes[CONSTANTS.TAXONOMIAS_FILTROS[0].slug]}
                                recorteTerritorial={props.filters.recorteTerritorial}
                                changeFilter={changeFilter}
                            />
                        </FormControl>

                        <label className="perfilCadastramentoLabel">
                            Perfil do cadastramento
                        </label>

                        {CONSTANTS.TAXONOMIAS_FILTROS.filter((tax) => {return tax.slug !== 'localizacao'}).map((tax, i) => (
                            <FormControl fullWidth key={tax.slug} className={i > 0 ? "mt-3" : ""}>
                                <SelectTax
                                    key={`selectTax_${tax.slug}`}
                                    tax={tax}
                                    isMobile={props.isMobile}
                                    filtersTax={props.filters[tax.slug]}
                                    opcoesTax={props.opcoes[tax.slug]}
                                    recorteTerritorial={props.filters.recorteTerritorial}
                                    changeFilter={changeFilter}
                                />
                            </FormControl>
                        ))}

                        {isMobile && props.qtdeFichas > 0 && Object.keys(props.intervaloData).length > 0 && props.intervaloData.step > 0 &&
                            <div id="intervaloDataWrapperMobile">
                                <IntervaloDataFilter
                                    intervaloDataValue={props.filters.intervaloDataValue}
                                    intervaloData={props.intervaloData}
                                    onChangeValue={changeFilter}
                                    isMobile={props.isMobile}
                                />
                            </div>
                        }
                    </div>
                    <div key="menuFiltrosFooter" className="menuFiltrosFooter">
                        <Button
                            className="botaoLimparFiltros"
                            variant="menuFiltrosBtn"
                            onClick={resetFilters}
                            size="sm"
                        >
                            Limpar Filtros
                        </Button>
                    </div>
                </div>
            }
        </>
    );
}
